import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCart } from 'features/FeatureManager'

import SettingsModule from 'modules/settings'

import {
    showUpdatePaymentMethod,
    showSubscribe,
    showAddPaymentMethod,
    usePopup,
    Subscribe,
    AddPaymentMethod,
    UpdatePaymentMethod,
    getCurrentPopup,
} from 'features/cartUI'

const Cart = ({
    ctaId = null,
    ctaSessionId = null,
    app = null,
    onCartStarted = (props = {}) => {},
    onComplete = (props = {}) => {},
    onCartDismissed = (props = {}) => {},
    onCartFailed = (props = {}) => {},
    pricingId = null,
} = {}) => {
    const { checkout, dismissCart, purchaseStatus } = useCart({
        ctaId,
        ctaSessionId,
        userId: app?.userId,
        publisherId: app?.publisherId,
        onCartStarted,
        onComplete,
        onCartDismissed,
        onCartFailed,
    })

    const defaultSource = SettingsModule.hooks.useDefaultSource()

    const buyProductPricing = useCallback(() => {
        checkout(pricingId)
    }, [checkout, pricingId])

    const { setModalOpen, Popup } = usePopup()

    const dispatch = useDispatch()
    const currentPopup = useSelector(getCurrentPopup)

    const _showUpdatePaymentMethod = useCallback(() => {
        dispatch(showUpdatePaymentMethod())
    }, [dispatch])

    const _showSubscribe = useCallback(() => {
        dispatch(showSubscribe())
    }, [dispatch])

    const _showAddPaymentMethod = useCallback(() => {
        dispatch(showAddPaymentMethod())
    }, [dispatch])

    useEffect(() => {
        setModalOpen(true)
        if (!defaultSource) {
            _showAddPaymentMethod()
        } else {
            _showSubscribe()
        }
    }, [defaultSource, _showAddPaymentMethod, _showUpdatePaymentMethod])

    return (
        <>
            <Popup
                onAfterClose={() => {
                    setModalOpen(false)
                    dismissCart()
                }}
            >
                {currentPopup === 'Subscribe' && (
                    <Subscribe
                        app={app}
                        productPricingId={pricingId}
                        showUpdatePaymentMethod={_showUpdatePaymentMethod}
                        subscribe={buyProductPricing}
                        cancel={() => {
                            setModalOpen(false)
                        }}
                        purchaseStatus={purchaseStatus}
                    />
                )}
                {currentPopup === 'UpdatePaymentMethod' && (
                    <UpdatePaymentMethod
                        onChange={(data) => {
                            console.log('onChange', data)
                        }}
                        onCancel={_showSubscribe}
                        onError={onCartFailed}
                    />
                )}
                {currentPopup === 'AddPaymentMethod' && (
                    <AddPaymentMethod
                        onSuccess={_showSubscribe}
                        onCancel={() => {
                            setModalOpen(false)
                        }}
                        onError={onCartFailed}
                    />
                )}
            </Popup>
        </>
    )
}

export default Cart
